<template>
	<picker ref="picker"
		class="v5-datepicker"
		@on-select="handleSelect(arguments)"
		:data="dayData"
		:selected-index="scrollIndex"
		:title="title"
		@on-change="handleChange"
		:cancelTxt="cancelTxt"
		:confirmTxt="confirmTxt">
	</picker>
</template>

<script>
/**
 * @desc date-picker 组件
 * @param {number} [type] - date 类型 (0-年月日 1-年月)
 * @param {string} [title] - picker 标题
 * @param {string} [cancelTxt] - 取消按钮
 * @param {string} [confirmTxt] - 确定按钮
 * @param {array} [day] - 当前日期
 * @param {array} [min] - 日期下限
 * @param {array} [max] - 日期上限
 */
import Picker from '../picker';

export default {
	name: 'DatePicker',
	props: {
		type: {
			type: Number,
			default: 0 // 0-年月日 1-年月
		},
		title: {
			type: String
		},
		cancelTxt: {
			type: String,
			default: '取消'
		},
		confirmTxt: {
			type: String,
			default: '确定'
		},
		day: {
			type: Array,
			default() {
				return [new Date().getFullYear(), new Date().getMonth() + 1, new Date().getDate()];
			}
		},
		min: {
			type: Array,
			default() {
				return [2000, 1, 1];
			}
		},
		max: {
			type: Array,
			default() {
				return [2100, 12, 31];
			}
		}
	},
	data() {
		return {
			tempIndex: new Array(this.type === 1 ? 2 : 3).fill(0)
		};
	},
	created() {
		this.initTempIndex();
		this.scrollIndex = [...this.tempIndex]; // 初始索引值
	},
	watch: {
		dayData() {
			this._first && this.$refs.picker.refresh();
			this._first = true;
		}
	},
	methods: {
		show() {
			this.$refs.picker.setData(this.dayData);
			this.$refs.picker.show();
		},
		handleSelect(args) {
			this.$emit('on-select', ...args);
		},
		handleChange(i, newIndex) {
			if (newIndex !== this.tempIndex[i]) {
				this.tempIndex.splice(i, 1, newIndex);
				for (let j = this.tempIndex.length - 1; j > i; j--) {
					this.tempIndex.splice(j, 1, 0);
					setTimeout(() => {
						this.$refs.picker.scrollTo(j, 0);
					}, 80);
				}
			}
		},
		/**
		 * 初始化索引值
		 */
		initTempIndex() {
			const [yearList, monthList, dayList] = this.dataList;
			let first = yearList
				.map(el => el.value)
				.indexOf(`${this.day[0]}`);
			this.tempIndex.splice(0, 1, first);
			let second = monthList[yearList[first].value]
				.map(el => el.value)
				.indexOf(`${this.day[0]}${this.fixNum(this.day[1])}`);
			this.tempIndex.splice(1, 1, second);
			if (this.type !== 1) {
				let third = dayList[monthList[yearList[first].value][second].value]
					.map(el => el.value)
					.indexOf(`${this.day[0]}${this.fixNum(this.day[1])}${this.fixNum(this.day[2])}`);
				this.tempIndex.splice(2, 1, third);
			}
		},
		/**
		 * 获取范围内的数组
		 */
		range(n, m, polyfill = false, unit = '', base = '') {
			let arr = [];
			for (let i = n; i <= m; i++) {
				let value = polyfill ? this.fixNum(i) : i;
				arr.push({
					text: value + unit,
					value: base + value
				});
			}
			return arr;
		},
		/**
		 * 格式化数字
		 */
		fixNum(num) {
			return num < 10 ? '0' + num : num;
		}
	},
	computed: {
		/**
		 * 获取范围内的全部日期数据
		 */
		dataList() {
			let yearList = this.range(this.min[0], this.max[0], false, '年');
			let monthList = {};
			let dayList = {};
			yearList.forEach(year => {
				let curYearVal = +year.value;
				let minMonth = curYearVal === this.min[0] ? this.min[1] : 1;
				let maxMonth = curYearVal === this.max[0] ? this.max[1] : 12;
				let tempMonth = this.range(minMonth, maxMonth, true, '月', year.value);
				monthList[year.value] = [];
				monthList[year.value] = tempMonth;
				tempMonth.forEach(month => {
					let curMonthVal = +month.value.substring(4);
					let day = 30;
					if ([1, 3, 5, 7, 8, 10, 12].indexOf(curMonthVal) > -1) {
						day = 31;
					} else {
						if (curMonthVal === 2) {
							day = !(curYearVal % 400) || (!(curYearVal % 4) && curYearVal % 100) ? 29 : 28;
						}
					}
					let minDay = curYearVal === this.min[0] && curMonthVal === this.min[1] ? this.min[2] : 1;
					let maxDay = curYearVal === this.max[0] && curMonthVal === this.max[1] ? this.max[2] : day;
					let tempDate = this.range(minDay, maxDay, true, '日', month.value);
					dayList[month.value] = [];
					dayList[month.value] = tempDate;
				});
			});
			return [yearList, monthList, dayList];
		},
		/**
		 * 初始化当前显示日期
		 */
		dayData() {
			const [yearList, monthList, dayList] = this.dataList;
			const years = yearList;
			const months = monthList[years[this.tempIndex[0]].value];
			if (this.type !== 1) {
				const days = dayList[months[this.tempIndex[1]].value];
				return [years, months, days];
			}
			return [years, months];
		}
	},
	components: {
		Picker
	}
};
</script>

<style lang="scss">
@import './style.scss';
</style>
